import { render, staticRenderFns } from "./centerOrder.vue?vue&type=template&id=8ffe5714&"
import script from "./centerOrder.vue?vue&type=script&lang=js&"
export * from "./centerOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports